"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROLLBACK_MERGE_REQUEST_EXAMPLE = exports.MERGE_PATIENT_REQUEST_EXAMPLE = exports.rollbackMergeRequestSchema = exports.mergePatientRequestSchema = void 0;
const zod_1 = require("zod");
exports.mergePatientRequestSchema = zod_1.z.object({
    sourcePatientId: zod_1.z.string().uuid(),
    targetPatientId: zod_1.z.string().uuid(),
    reason: zod_1.z.string().min(1),
    initiatedBy: zod_1.z.string().uuid(),
    matchCandidateId: zod_1.z.string().uuid().optional(),
});
exports.rollbackMergeRequestSchema = zod_1.z.object({
    mergeId: zod_1.z.string().uuid(),
    initiatedBy: zod_1.z.string().uuid(),
    reason: zod_1.z.string().min(1),
});
exports.MERGE_PATIENT_REQUEST_EXAMPLE = {
    sourcePatientId: '22222222-2222-2222-2222-222222222222',
    targetPatientId: '33333333-3333-3333-3333-333333333333',
    reason: 'Confirmed duplicate via IdentityResolutionCandidate review',
    initiatedBy: '99999999-9999-9999-9999-999999999999',
};
exports.ROLLBACK_MERGE_REQUEST_EXAMPLE = {
    mergeId: '44444444-4444-4444-4444-444444444444',
    initiatedBy: '99999999-9999-9999-9999-999999999999',
    reason: 'Merged in error — patients confirmed distinct after the fact',
};
//# sourceMappingURL=merge.request.js.map